import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\SegmentController::store
* @see app/Http/Controllers/Creator/SegmentController.php:16
* @route '/app/creator/campaigns/segments'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns/segments',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\SegmentController::store
* @see app/Http/Controllers/Creator/SegmentController.php:16
* @route '/app/creator/campaigns/segments'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SegmentController::store
* @see app/Http/Controllers/Creator/SegmentController.php:16
* @route '/app/creator/campaigns/segments'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SegmentController::store
* @see app/Http/Controllers/Creator/SegmentController.php:16
* @route '/app/creator/campaigns/segments'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SegmentController::store
* @see app/Http/Controllers/Creator/SegmentController.php:16
* @route '/app/creator/campaigns/segments'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Creator\SegmentController::update
* @see app/Http/Controllers/Creator/SegmentController.php:44
* @route '/app/creator/campaigns/segments/{segment}'
*/
export const update = (args: { segment: string | { uuid: string } } | [segment: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/app/creator/campaigns/segments/{segment}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Creator\SegmentController::update
* @see app/Http/Controllers/Creator/SegmentController.php:44
* @route '/app/creator/campaigns/segments/{segment}'
*/
update.url = (args: { segment: string | { uuid: string } } | [segment: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { segment: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { segment: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            segment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        segment: typeof args.segment === 'object'
        ? args.segment.uuid
        : args.segment,
    }

    return update.definition.url
            .replace('{segment}', parsedArgs.segment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SegmentController::update
* @see app/Http/Controllers/Creator/SegmentController.php:44
* @route '/app/creator/campaigns/segments/{segment}'
*/
update.put = (args: { segment: string | { uuid: string } } | [segment: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Creator\SegmentController::update
* @see app/Http/Controllers/Creator/SegmentController.php:44
* @route '/app/creator/campaigns/segments/{segment}'
*/
const updateForm = (args: { segment: string | { uuid: string } } | [segment: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SegmentController::update
* @see app/Http/Controllers/Creator/SegmentController.php:44
* @route '/app/creator/campaigns/segments/{segment}'
*/
updateForm.put = (args: { segment: string | { uuid: string } } | [segment: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Creator\SegmentController::destroy
* @see app/Http/Controllers/Creator/SegmentController.php:66
* @route '/app/creator/campaigns/segments/{segment}'
*/
export const destroy = (args: { segment: string | { uuid: string } } | [segment: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/app/creator/campaigns/segments/{segment}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Creator\SegmentController::destroy
* @see app/Http/Controllers/Creator/SegmentController.php:66
* @route '/app/creator/campaigns/segments/{segment}'
*/
destroy.url = (args: { segment: string | { uuid: string } } | [segment: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { segment: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { segment: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            segment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        segment: typeof args.segment === 'object'
        ? args.segment.uuid
        : args.segment,
    }

    return destroy.definition.url
            .replace('{segment}', parsedArgs.segment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SegmentController::destroy
* @see app/Http/Controllers/Creator/SegmentController.php:66
* @route '/app/creator/campaigns/segments/{segment}'
*/
destroy.delete = (args: { segment: string | { uuid: string } } | [segment: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Creator\SegmentController::destroy
* @see app/Http/Controllers/Creator/SegmentController.php:66
* @route '/app/creator/campaigns/segments/{segment}'
*/
const destroyForm = (args: { segment: string | { uuid: string } } | [segment: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SegmentController::destroy
* @see app/Http/Controllers/Creator/SegmentController.php:66
* @route '/app/creator/campaigns/segments/{segment}'
*/
destroyForm.delete = (args: { segment: string | { uuid: string } } | [segment: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const segments = {
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default segments